import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { tr } from '../til';

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

// Xarita bosilganda koordinatani formaga uzatadi.
function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng);
    }
  });
  return null;
}

// Xarita konteyneri chizilgandan keyin o'lchamini qayta hisoblaydi.
//
// Leaflet o'lchamni bir marta, chizilganda oladi. Konteyner keyinroq
// kengaysa (modal oynada, grid ichida), xarita eski o'lchamda qoladi va
// ko'rinadigan joy uchun plitka so'ramaydi — ekranda bo'sh maydon turadi.
function Olcham() {
  const map = useMap();
  React.useEffect(() => {
    const yangila = () => map.invalidateSize();
    const t = setTimeout(yangila, 250);
    window.addEventListener('resize', yangila);
    return () => { clearTimeout(t); window.removeEventListener('resize', yangila); };
  }, [map]);
  return null;
}

// Koordinata tashqaridan o'zgarganda (masalan qo'lda yozilganda)
// xaritani o'sha joyga suradi.
function Recenter({ latitude, longitude }) {
  const map = useMap();
  const lat = Number(latitude);
  const lng = Number(longitude);

  React.useEffect(() => {
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      map.setView([lat, lng], map.getZoom() < 14 ? 16 : map.getZoom());
    }
  }, [lat, lng, map]);

  return null;
}

/// Ish zonasini xaritadan tanlash.
///
/// Xaritada bosilganda koordinata avtomatik olinadi va radius doirasi
/// darhol chiziladi — admin qo'lda son yozishi shart emas.
function ZonePicker({ latitude, longitude, radius, onPick }) {
  const [locating, setLocating] = useState(false);
  const [geoError, setGeoError] = useState('');

  const lat = Number(latitude);
  const lng = Number(longitude);
  const hasPoint = Number.isFinite(lat) && Number.isFinite(lng) && latitude !== '' && longitude !== '';

  // Nuqta tanlanmagan bo'lsa O'zbekiston markazidan boshlaymiz.
  const center = hasPoint ? [lat, lng] : [41.3775, 64.5853];
  const zoom = hasPoint ? 16 : 6;

  const useMyLocation = () => {
    if (!navigator.geolocation) {
      setGeoError(tr("Brauzer joylashuvni qo'llab-quvvatlamaydi"));
      return;
    }
    setLocating(true);
    setGeoError('');

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocating(false);
        onPick(pos.coords.latitude, pos.coords.longitude);
      },
      () => {
        setLocating(false);
        setGeoError(tr("Joylashuvni aniqlab bo'lmadi. Brauzerda ruxsat berganingizni tekshiring."));
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
  };

  return (
    <div>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        marginBottom: '8px', flexWrap: 'wrap'
      }}>
        <span style={{ color: '#666', fontSize: '13px' }}>
          🗺️ {tr("Xaritada ish joyini bosing — koordinata avtomatik olinadi")}
        </span>
        <button
          type="button"
          onClick={useMyLocation}
          disabled={locating}
          style={{
            marginLeft: 'auto', padding: '6px 12px',
            background: '#eef1f7', color: '#1a1a2e',
            border: '1px solid #ddd', borderRadius: '8px',
            fontSize: '12px', cursor: locating ? 'default' : 'pointer'
          }}
        >
          {locating ? tr("Aniqlanmoqda...") : tr("📍 Men shu yerdaman")}
        </button>
      </div>

      {geoError && (
        <div style={{
          background: '#fff8e6', color: '#8a6d2d', padding: '8px 12px',
          borderRadius: '8px', fontSize: '12px', marginBottom: '8px'
        }}>
          {geoError}
        </div>
      )}

      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: '320px', width: '100%', borderRadius: '10px' }}
        scrollWheelZoom
      >
        {/* Plitkalar o'z serverimiz orqali (nginx /tiles/). Idoraviy
            tarmoqdan tile.openstreetmap.org ochilmay, xarita bo'sh
            qolayotgan edi; nginx ularni olib beradi va keshlaydi. */}
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="/tiles/{z}/{x}/{y}.png"
          maxZoom={19}
        />
        <Olcham />
        <ClickHandler onPick={onPick} />
        <Recenter latitude={latitude} longitude={longitude} />

        {hasPoint && (
          <>
            <Marker position={[lat, lng]} />
            <Circle
              center={[lat, lng]}
              radius={Number(radius) > 0 ? Number(radius) : 200}
              pathOptions={{ color: '#2d8a2d', fillColor: '#2d8a2d', fillOpacity: 0.15 }}
            />
          </>
        )}
      </MapContainer>

      {hasPoint && (
        <div style={{ color: '#888', fontSize: '12px', marginTop: '6px' }}>
          {tr("Tanlangan:")} <strong>{lat.toFixed(6)}, {lng.toFixed(6)}</strong>
          · {tr("yashil doira —")} {Number(radius) > 0 ? radius : 200} {tr("m radius")}
        </div>
      )}
    </div>
  );
}

export default ZonePicker;
